export default __webpack_public_path__ + "static/media/inter-light-beta-webfont.6809abed.woff2";